export default __webpack_public_path__ + "static/fox-f9b9d6df966714e9feffc490073e7267.png";